<div i18n-style="@@direction" style="direction: ltr">
  <div class="users">
  </div>
</div>
